import { render } from "./FestivalTip.vue?vue&type=template&id=2855e162&scoped=true"
import script from "./FestivalTip.vue?vue&type=script&lang=js"
export * from "./FestivalTip.vue?vue&type=script&lang=js"

import "./FestivalTip.vue?vue&type=style&index=0&id=2855e162&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2855e162"]])

export default __exports__